import { PresenceContext } from "framer-motion";
import { displayName, InputComponentProps } from "./Filters";
import { Display_Value_Key as dvk } from "../Create/utils";

import { useState, useEffect } from "react";
import { mediaDurationValueMapping } from "@/utils/utilFunctions/filters";

// Radio input component
const RenderRadioOptions: React.FC<InputComponentProps> = ({
  filter,
  options = [],
  onChange,
  preSelected,
  onApplyStateChange,
}) => {
  const [selectedOption, setSelectedOption] = useState<string | number>("");
  const [input, setInput] = useState<string>("");
  const [selectedName, setSelectedName] = useState<string>("");

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInput(e.target.value);
  };

  const filteredOptions =
    input === "" ? options : options.filter((o) => o.value.includes(input));

  const handleOnchange = (event: any, name: string) => {
    setSelectedOption(event.target.value);
    setSelectedName(name);
  };

  const handleOnApply = () => {
    if (selectedOption) {
      if (filter.name === "media_duration") {
        // let duration=mediaDurationValueMapping[selectedOption];
        const key =
          selectedOption.toString() as keyof typeof mediaDurationValueMapping;
        const range = {
          "meta.duration": mediaDurationValueMapping[key],
        };
        onChange(filter.name, range, selectedName);
      } else if (filter.name === "type") {
        const type = {
          "meta.type": selectedOption,
        };
        onChange(filter.name, type, selectedName);
      } else {
        onChange(filter.name, selectedOption, selectedName);
      }
    }
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter" && selectedOption) {
        handleOnApply();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedOption]);

  useEffect(() => {
    if (preSelected[filter.name]) {
      if (preSelected["media_duration" + dvk]) {
        setSelectedOption(preSelected["media_duration" + dvk]);
      } else if (preSelected["type"]) {
        const typeValue = preSelected["type"]["meta.type"];
        setSelectedOption(typeValue);
      } else {
        setSelectedOption(preSelected[filter.name]);
      }
    }
  }, []);

  // Update apply state whenever selectedOption changes
  useEffect(() => {
    if (onApplyStateChange) {
      onApplyStateChange(!selectedOption, handleOnApply, "Apply");
    }
  }, [selectedOption, onApplyStateChange]);

  return (
    <div className="px-3">
      <div
        className="mb-3 py-3 border-bottom"
        style={{ overflow: "auto", overflowX: "hidden" }}
      >
        {/* <input type="text" value={input} onChange={handleInputChange} className="form-control form-control-sm mb-1" /> */}
        <div className="px-2" style={{ maxHeight: "300px", overflow: "auto" }}>
          {filteredOptions.map((option, index) => (
            <div
              className="form-check mb-2 d-flex gap-2 align-items-center"
              key={index}
            >
              <input
                className="form-check-input"
                type="radio"
                name={filter.name}
                id={`radio-${index}`}
                value={option.value}
                checked={selectedOption === option.value}
                onChange={(e) => handleOnchange(e, option.label)}
              />
              <label className="form-check-label" htmlFor={`radio-${index}`}>
                {option.label}
              </label>
            </div>
          ))}
        </div>
      </div>

      {/* <div className="d-flex justify-content-end">
        <button className="btn btn-primary btn-sm text-white" disabled={!selectedOption} onClick={handleOnApply}>
          Apply
        </button>
      </div> */}
    </div>
  );
};

export default RenderRadioOptions;
